/**
* @name APP u-faculty
* @autor daniel.molina@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: customChartController
* # alias: custCtrl
*/

export default class customChartController {

    constructor($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, ReviewSrv,integralEvaluationSrv,$cookies) {
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.ngNotify = ngNotify;
        this.$stateParams = $stateParams;
        this.ReviewSrv = ReviewSrv
        this.integralEvaluationSrv = integralEvaluationSrv
        this.userinfo = null;
        this.$scope.UserInfoConstant = UserInfoConstant

        this.teacherId  = this.$stateParams.teacherId
        this.workplanId = this.$stateParams.workplanId
        this.optionList ={}
        this.optionListClean ={}
        // this.period=0
        // this.level=0
        // this.unit=0


        this.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
            if (details !== undefined) {
                this.cookiesUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false
                this.userinfo = details.user;
                this.main();
            }
        });

    }

    mostrar(){

        var period=this.period
        var level=this.level
        var unit=this.unit
        this.main()
       

    }

    reiniciar(){
       delete this.period
       delete this.level
       delete this.unit
       this.main()
    }

    optionsList(){

       var THIS=this;
       var param={id_teacher:this.teacherId,id_work_plan:this.workplanId}
       this.ReviewSrv.getGraphSelectionListMethod.get(param).$promise.then(function (dataReturn) {
         THIS.optionList=dataReturn.data
         THIS.optionListClean=dataReturn.data     
       }, function (data) {
            console.log('error',data)
         }
      )

    }

    main() {
        console.log('Estoy en el controlador de customChartController')

         var THIS=this
         var param={teacherId:this.teacherId,
                    workplanId:this.workplanId,
                    idPeriod:this.period,
                    idLevel:this.level,
                    idUnit:this.unit
                  };

         this.optionsList()

         this.graphs=[]
         this.subjectIncrementCode=0;

         this.integralEvaluationSrv.getGraphicAsignature.getGraphic(param).$promise.then(function (dataReturn) {
           
           if(dataReturn.data.length<0){
            THIS.graph=[]
           }else{
                THIS.graph=dataReturn.data
                THIS.subjectIncrementCode=dataReturn.data[0].id_code
                THIS.barGraphId=dataReturn.data[0].groups[0].quantitative[0].dim[0].id
                THIS.$timeout(function() {
                    THIS.drawGraph(THIS.graph)
                }, 1000);
           }
        



           }, function (data) {
            console.log('error',data)
          }
          )

    }


    drawGraph(graph){
    
            this.chartConfig={}


                for(var i in graph){
                 for(var i1 in graph[i].groups){  
                  for(var  j1 in graph[i].groups[i1].quantitative[0].dim){
                      for(var  j in graph[i].groups[i1].quantitative[0].dim[j1].analysis){
                  
                                var chartVar= {
                                    chart: {
                                        plotBackgroundColor: null,
                                        plotBorderWidth: null,
                                        plotShadow: false,
                                        type: 'pie'
                                    },
                                    title: {
                                        text: ''
                                    },
                                    credits: {
                                        enabled: false
                                    },        
                                    exporting: { 
                                        enabled: false 
                                    },    
                                    tooltip: {
                                        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                                    },
                                    plotOptions: {
                                        pie: {
                                            allowPointSelect: true,
                                            cursor: 'pointer',
                                            dataLabels: {
                                                enabled: false,
                                                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                                                style: {
                                                    color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                                                }
                                            }
                                        }
                                    },
                                    series: [{
                                        name: 'Brands',
                                        colorByPoint: true,
                                        data: graph[i].groups[i1].quantitative[0].dim[j1].analysis[j].barGraph
                                    }]
                                    };

                             Highcharts.chart('resultados'+graph[i].groups[i1].quantitative[0].dim[j1].analysis[j].highChart+'Chart',chartVar);
                    }       
                  }
                }

                }

    }

    autoevaluation(){
        this.ReviewSrv.getAutoevaluation.Autoevaluation().$promise.then((dataReturn) => {
        if (dataReturn.status === true) {
            this.reflection = dataReturn.data.reflection            
        } else {
          console.log(dataReturn)
        }
      })
    }


}

customChartController.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant','ReviewSrv','integralEvaluationSrv','$cookies'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/summary/evaluacionDeProfesoresTemplates/customChartController.js